import { Project, BlogPost, Skill, Experience } from '../types';

export const projects: Project[] = [
  {
    id: 'synapse',
    title: 'Synapse',
    description: 'Empresa con más de 15 años de experiencia en diseño y desarrollo de software a medida. Ofrecemos servicios integrales para la digitalización de empresas incluyendo intranets, web corporativas, ERPs, CRMs y hosting.',
    image: '/synapse-logo.png',
    technologies: ['PHP', 'MySQL', 'JavaScript', 'HTML5', 'CSS3', 'JQuery', 'Bootstrap'],
    link: 'https://synapse.es',
    type: 'company'
  },
  {
    id: 'creapptiva',
    title: 'Creapptiva',
    description: 'Empresa dedicada al diseño de apps móviles. Nuestro lema es "We start up your start-up" y hemos lanzado proyectos de emprendedores como Futboling, UtilEver y apps de eventos como FIC.',
    image: '/creapptiva-logo.png',
    technologies: ['Objective-C', 'iOS', 'Swift', 'React Native'],
    link: 'https://creapptiva.com',
    type: 'company'
  },
  {
    id: 'esnews',
    title: 'eSNews',
    description: 'App de noticias para iOS que permite encontrar las noticias más destacadas de medios nacionales e internacionales. Llegamos a estar en el nº 1 en AppStore en la sección de noticias.',
    image: '/esnews-logo.png',
    technologies: ['Objective-C', 'iOS', 'API Integration', 'SQLite'],
    type: 'app'
  }
];

export const blogPosts: BlogPost[] = [
  {
    id: 'web-components',
    title: 'Web Components',
    excerpt: '¿Qué son los web components? Algunas librerías como React o Vue, y frameworks como Angular e Ionic trabajan desde la perspectiva de los web components.',
    content: `
# Web Components

¿Qué son los web components? Algunas librerías como React o Vue, y frameworks como Angular e Ionic trabajan desde la perspectiva de los web components.

Los web components contienen diferentes tecnologías y especificaciones que facilitan al desarrollador la posibilidad de crear componentes personalizados y reutilizables.

## Tecnologías principales

1. **Custom Elements**: Permiten crear nuevos elementos HTML
2. **Shadow DOM**: Aísla el estilo y el markup del componente
3. **HTML Templates**: Permiten definir fragmentos de HTML reutilizables
4. **ES Modules**: Facilitan la importación y exportación de componentes

## Ventajas

- **Reutilizabilidad**: Los componentes pueden ser usados en diferentes proyectos
- **Encapsulación**: El estilo y la lógica están aislados
- **Interoperabilidad**: Funcionan con cualquier framework o librería
    `,
    date: '2021-03-25',
    author: 'Irina Sanchez',
    category: 'desarrollo web',
    tags: ['web components', 'javascript', 'html5']
  },
  {
    id: 'multiples-versiones-xcode',
    title: 'Múltiples versiones de una app dentro de Xcode',
    excerpt: 'Una de las cosas más útiles a la hora de trabajar con múltiples versiones de una misma app (por ejemplo una versión Free y otra de Pago), es poder gestionarlas de manera eficiente.',
    content: `
# Múltiples versiones de una app dentro de Xcode

Una de las cosas más útiles a la hora de trabajar con múltiples versiones de una misma app (por ejemplo una versión Free y otra de Pago), es poder gestionarlas de manera eficiente. Y no hay mejor forma que dentro del mismo proyecto de Xcode.

## Configuración de Targets

Para gestionar múltiples versiones, necesitamos:

1. **Crear nuevos Targets**: Duplicar el target principal para cada variante
2. **Configurar Build Settings**: Ajustar las configuraciones específicas de cada versión
3. **Gestionar Assets**: Organizar los recursos para cada target
4. **Schemes Diferentes**: Crear schemes específicos para cada versión

## Beneficios

- **Mantenimiento Centralizado**: Todo el código común está en un solo lugar
- **Build Automatizado**: Compilar diferentes versiones desde el mismo proyecto
- **Gestión Eficiente**: Cambios compartidos automáticamente entre versiones
    `,
    date: '2013-07-30',
    author: 'Fernando Javier Pinilla Barrena',
    category: 'iOS Dev',
    tags: ['ios', 'xcode', 'target', 'versiones']
  },
  {
    id: 'snippets-ios',
    title: 'Snippets para iOS que deberías saber',
    excerpt: 'Retomando el blog, me gustaría hacer una pequeña relación de snippets para iOS que deberías saber. Son sólo una primera parte de una serie de post que iré completando con el tiempo.',
    content: `
# Snippets para iOS que deberías saber

Retomando el blog, me gustaría hacer una pequeña relación de snippets para iOS que deberías saber. Son sólo una primera parte de una serie de post que iré completando con el tiempo e irán aumentando en complejidad.

## Snippets útiles

### 1. Crear un UIAlertView

\`\`\`objective-c
UIAlertView *alert = [[UIAlertView alloc] initWithTitle:@"Título" 
                                                message:@"Mensaje" 
                                               delegate:nil 
                                      cancelButtonTitle:@"OK" 
                                      otherButtonTitles:nil];
[alert show];
\`\`\`

### 2. Guardar datos en NSUserDefaults

\`\`\`objective-c
NSUserDefaults *defaults = [NSUserDefaults standardUserDefaults];
[defaults setObject:@"valor" forKey:@"clave"];
[defaults synchronize];
\`\`\`

### 3. Hacer una petición HTTP simple

\`\`\`objective-c
NSURL *url = [NSURL URLWithString:@"https://api.ejemplo.com"];
NSURLRequest *request = [NSURLRequest requestWithURL:url];
[NSURLConnection sendAsynchronousRequest:request 
                                   queue:[NSOperationQueue mainQueue] 
                       completionHandler:^(NSURLResponse *response, NSData *data, NSError *error) {
    // Procesar respuesta
}];
\`\`\`

Estos son solo algunos ejemplos básicos que te ayudarán en el día a día del desarrollo iOS.
    `,
    date: '2013-07-23',
    author: 'Fernando Javier Pinilla Barrena',
    category: 'iOS Dev',
    tags: ['ios', 'snippets', 'objective-c', 'tips']
  }
];

export const skills: Skill[] = [
  {
    category: 'Lenguajes',
    items: ['Objective-C', 'PHP', 'JavaScript', 'HTML5', 'CSS3']
  },
  {
    category: 'Frameworks',
    items: ['JQuery', 'Bootstrap', 'Cocoa-Touch (iOS)', 'React', 'Vue.js']
  },
  {
    category: 'Bases de Datos',
    items: ['MySQL', 'SQL Server', 'SQLite', 'MongoDB']
  },
  {
    category: 'Herramientas',
    items: ['JIRA', 'Git', 'Xcode', 'Docker', 'AWS']
  }
];

export const experiences: Experience[] = [
  {
    company: 'Synapse Asesores Informáticos, S.L.',
    position: 'Fundador y Desarrollador',
    period: '2008 - Presente',
    description: 'Desarrollo de software a medida, webs corporativas, intranets, ERPs y CRMs. Gestión de equipos y proyectos con metodologías ágiles.',
    type: 'work'
  },
  {
    company: 'Creapptiva Extremadurensys',
    position: 'Fundador y Desarrollador iOS',
    period: '2011 - Presente',
    description: 'Desarrollo de aplicaciones nativas para iPhone y iPad con conexión a APIs y backends. Proyectos destacados: eSNews, Futboling, apps para eventos.',
    type: 'work'
  },
  {
    company: 'Escuela Politécnica de Mérida (Universidad de Extremadura)',
    position: 'Ingeniería Informática',
    period: '2004 - 2009',
    description: 'Formación en desarrollo de software, bases de datos y sistemas. Especialización en desarrollo web y aplicaciones de escritorio.',
    type: 'education'
  }
];